import { Outlet } from 'react-router-dom';
import { Spin } from 'antd';
import { useRestoreSession } from '../auth/useRestoreSession';
import { useSession } from '../auth/session';

/**
 * Gốc của mọi route. Chạy khôi phục phiên đúng MỘT lần cho cả app và chặn render
 * cho tới khi xong — nếu không, tải lại trang sẽ chớp qua màn đăng nhập rồi mới
 * nhảy vào trang, và người dùng kịp bấm nhầm vào form đăng nhập đó.
 */
export function RootLayout() {
  useRestoreSession();

  const isRestoring = useSession((state) => state.isRestoring);

  if (isRestoring) {
    return (
      <div style={{ display: 'grid', placeItems: 'center', height: '100vh' }}>
        <Spin size="large" aria-label="Đang khôi phục phiên đăng nhập" />
      </div>
    );
  }

  return <Outlet />;
}
